import React from 'react';
import PropTypes from 'prop-types';
import { QuestionCircleOutlined } from 'opencare-crown';

import { webWidget } from 'utils/zendesk';

import { Button } from './styled-components';

const HelpButton = ({ margin }) => {
  const openHelp = () => {
    if (webWidget.isReady()) {
      webWidget.showAndOpen();
    } else {
      window.open('https://support.opencare.com', '_blank');
    }
  };

  return (
    <Button type="button" onClick={openHelp} margin={margin}>
      <QuestionCircleOutlined aria-hidden />
      Help
    </Button>
  );
};

HelpButton.propTypes = {
  margin: PropTypes.string,
};

export default HelpButton;
